import { Component, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AnimateComponent } from '@app/components/animate/animate.component';
import { SectionType } from '@app/models';

@Component({
  selector: 'app-end-top-section',
  templateUrl: './end-top-section.component.html',
  styleUrls: ['./end-top-section.component.scss'],
  imports: [NgOptimizedImage, AnimateComponent],
  standalone: true,
})
export class EndTopSectionComponent {
  public readonly navigationClick = output<SectionType>();
  protected readonly SectionType = SectionType;
}
